module.exports = __webpack_public_path__ + "static/img/xuanzhongmoshi.png@2x.4f946d62.png";